import React from 'react';

const AdTraceHeader = ({
    showTabs,
    showConsentTab,
    showInitialtmlTab,
    activeTab,
    setActive,
}) => {
    return (
        <div className="nav flexible mt-1">
            <div className="logo-link">
                <img
                    src="/static/images/Confiant_logo_full.svg"
                    alt="Confiant, Inc"
                />
                <span className="ad-trace-title mt-1 ml-2 flex-column">
                    AD TRACE
                </span>
            </div>

            {showTabs && (
                <div className="flex-5 flex-row ml-1 d-flex align-items-center justify-content-start">
                    {showConsentTab && (
                        <button
                            href="#"
                            role="tab"
                            className={`nav-item nav-link adtrace-header-button p-3 mr-1 uppercase ${
                                activeTab === 'consent' ? 'active' : 'inactive'
                            }`}
                            onClick={() => setActive('consent')}
                        >
                            Consent Details
                        </button>
                    )}

                    <button
                        href="#"
                        role="tab"
                        className={`nav-item nav-link uppercase adtrace-header-button p-3 ${
                            activeTab === 'html' ? 'active' : 'inactive'
                        }`}
                        onClick={() => setActive('html')}
                    >
                        HTML
                    </button>

                    {showInitialtmlTab && (
                        <button
                            href="#"
                            role="tab"
                            className={`nav-item nav-link uppercase adtrace-header-button p-3 ${
                                activeTab === 'initial_html'
                                    ? 'active'
                                    : 'inactive'
                            }`}
                            onClick={() => setActive('initial_html')}
                        >
                            Initial HTML
                        </button>
                    )}
                </div>
            )}
        </div>
    );
};

export default AdTraceHeader;
